import ProductScore from './ProductScore';

export default ProductScore;
